import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import BackButton from 'components/BackButton';
import ActionButton from 'components/ActionButton';
import { DATE_FORMATS, MODAL_TYPES, formatDate, showError, showSuccess } from 'utils';
import InfoModal from 'components/InfoModal';
import { deleteHomePageCollection, getHomePageCollectionDetail } from 'services/api/homePageCollection';
import { Loading } from 'components/loading/Loading';

const HomePageCollectionDetails = props => {
  const [loading, setLoading] = useState<boolean>(true);
  const [collection, setCollection] = useState<Record<string, any>>({});
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState<boolean>(false);
  const { collectionId } = props.match.params;

  const fetchCollectionDetails = async () => {
    try {
      const response = (await getHomePageCollectionDetail(collectionId)).toJSON();
      setCollection({
        ...response,
        cloudFunctionParams: JSON.stringify(response.cloudFunctionParams),
      });
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchCollectionDetails();
  }, []);
  
  const getDetailsSection = () => (
    <div className={styles['collection-details-container']}>
      <div>
        <div className={styles['label']}>Collection ID</div>
        <div className={styles['info']}>{collection.objectId}</div>
      </div>
      <div>
        <div className={styles['label']}>Created At</div>
        <div className={styles['info']}>
          {formatDate(collection.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A)}
        </div>
      </div>
      <div>
        <div className={styles['label']}>Active</div>
        <div className={styles['info']}>{collection.active?.toString()}</div>
      </div>
      <div>
        <div className={styles['label']}>Title</div>
        <div className={styles['info']}>{collection.title}</div>
      </div>
      <div>
        <div className={styles['label']}>Card Component</div>
        <div className={styles['info']}>{collection.componentName}</div>
      </div>
      <div>
        <div className={styles['label']}>Cloud Function</div>
        <div className={styles['info']}>{collection.cloudFunctionName}</div>
      </div>
      <div>
        <div className={styles['label']}>Params</div>
        <textarea
          disabled={true}
          className={'form-group'}
          value={collection.cloudFunctionParams}
        />
      </div>
    </div>
  );

  const handleDelete = async () => {
    try {
      await deleteHomePageCollection(collectionId);
      showSuccess('Collection deleted successfully');
      props.history.goBack();
    } catch (e) {
      showError(e);
    }
  };

  const getHeader = () => (
    <div className={styles['header']}>
      <div>
        <div className={styles['heading']}>Home Page Collection Details</div>
        <BackButton />
      </div>
      <div className={'d-flex'}>
        <ActionButton
          text={'Edit'}
          active={true}
          isLoading={false}
          onClick={() => props.history.push(`/home-page-collections/${collectionId}/edit`)}
          customClass={'mr-4'}
        />
        <ActionButton
          text={'Delete'}
          active={true}
          isLoading={false}
          onClick={() => setConfirmDeleteModalOpen(true)}
          customClass={styles['delete-button']}
        />
      </div>
    </div>
  );
  
  if (loading) return <Loading />;
  
  return (
    <div className={styles['home-page-details-container']}>
      {confirmDeleteModalOpen && (
        <InfoModal
          cancellable={true}
          type={MODAL_TYPES.CONFIRM_CHANGES}
          title={'Home Page Collection'}
          message={'Delete the Home Page Collection?'}
          toggleModal={() => setConfirmDeleteModalOpen(!confirmDeleteModalOpen)}
          primaryButtonText={'Delete'}
          primaryButtonOnClick={handleDelete}
          primaryButtonClass={styles['delete-button']}
          secondaryButtonText={'Cancel'}
          secondaryButtonOnClick={() => {
            setConfirmDeleteModalOpen(false);
          }}
          secondaryButtonClass={''}
        />
      )}
      {getHeader()}
      {getDetailsSection()}
    </div>
  );
};

export default HomePageCollectionDetails;